import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { CommonUtil } from '../../core/Utils/common-util';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';


@Component({
  selector: 'app-landing-tron',
  templateUrl: './landing-tron.component.html',
  styleUrls: ['./landing-tron.component.css']
})
export class LandingTronComponent implements OnInit {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  fragment: string;

  constructor(private rootScopeService: RootScopeService,
    public commonUtil: CommonUtil,
    private route: ActivatedRoute,
    private router: Router) {
      router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (event.url) {
            this.route.fragment.subscribe(fragment => this.fragment = fragment);
          }
        }
      });
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
    this.rootScopeData.pageName='Landing';
  }
  // tslint:disable-next-line: use-lifecycle-interface
  ngAfterViewChecked(): void {
    try {
      if (this.fragment) {
        const ele = <HTMLElement>document.querySelector('#' + this.fragment);
        ele.scrollIntoView();
      }
    } catch (e) { }
  }
}
